export default [
  // home
  {
    path: '/',
    module: 'home',
    title: 'Главная',
  },

  // auth pages
  {
    path: '/login/',
    module: 'user/login',
    title: 'Авторизация',
  },

  {
    path: '/login/client',
    module: 'user/loginClient',
    title: 'Авторизация',
  },


  // system
  {
    path: '/404',
    module: '404',
    title: '404 - Страница не найдена'
  },
  {
    path: '/403',
    module: '403',
    title: '403 - Доступ ограничен'
  },
];
